import convert from 'convert-units';
import moment from 'moment';

import TimeConversionUtils from './timeConversionUtils';

const inflection = require('inflection');

export default class Activity {
  setProps() {
    this.localStartTime = moment().format();
    this.activityId = null;
    this.duration = 0;
    this.totalDistance = 0;
    this.averageCadence = 0;
    this.averageGct = 0;
    this.activityTypeId = 0;
    this.weightedLoad = 0;
    this.averagePower = 0;
    this.altitudeGain = 0;
    this.altitudeLoss = 0;
    this.averageHr = 0;
    this.maximumHr = 0;
    this.w5sec = 0;
    // "dz" == "Duration in Zone"
    this.dz1 = 0;
    this.dz2 = 0;
    this.dz3 = 0;
    this.dz4 = 0;
    this.dz5 = 0;
  }

  constructor(activity = null) {
    this.setProps();

    const camelCaseDefaults = {};
    Object.keys(activity)
      .forEach(
        (key) => {
          camelCaseDefaults[inflection.camelize(key, true)] = activity[key];
        },
      );
    Object.assign(this, camelCaseDefaults);
    this.localStartTime = moment(this.localStartTime);
  }

  get zoneDurationSum() {
    return this.dz1 + this.dz2 + this.dz3 + this.dz4 + this.dz5;
  }

  get averagePaceRounded() {
    return 26.8224 / (this.totalDistance / this.duration);
  }

  get durationHours() {
    return +convert(+this.duration).from('s').to('h');
  }

  get durationForDisplay() {
    return TimeConversionUtils.prettyPrintFullDurationHoursMinutesSeconds(moment.duration(this.duration, 'seconds'));
  }

  get cadenceForDisplay() {
    return Math.round(this.averageCadence);
  }

  get totalDistanceMiles() {
    return convert(this.totalDistance).from('m').to('mi');
  }

  get id() {
    return this.activityId;
  }
}
